// extracted by mini-css-extract-plugin
module.exports = {"promotion":"_33Fmj","promotionAlert":"_1-DwF","promotionIconCheck":"JXhWn","promotionTitle":"Oi-_m","promotionSubTitle":"_1Mzyz","promotionEdit":"_3dZuH","link":"_3OYxT"};